import React from 'react'
import {Link} from '@reach/router'

import {ProductThumbnailFields} from './_gql-types/ProductThumbnailFields'

import {formatCurrency} from '../../utils/numbers'
import RatioImage from '../common/RatioImage'
import MissingProduct from '../../images/missing_product.png'


export default function ProductThumbnail(product: ProductThumbnailFields) {
  const price = formatCurrency(product.pricing?.priceRange?.start?.net?.amount)

  const units = product.weight
    ? <>({product.weight?.value} {product.weight?.unit})</>
    : undefined

  return (
    <Link to={`/verslun/vorur/${product.slug}/`} className="text-reset card-hover-wrapper d-flex">
      <div className="card border-0 rounded bg-white">
        <div className="pt-3">
          <RatioImage
            src={product.thumbnail?.url || MissingProduct}
            src2x={product.thumbnail2x?.url || MissingProduct}
            ratio={[4, 3]}
          />
        </div>

        <div className="card-body">
          <h6 className="card-title font-weight-bold mb-0">{product.name}</h6>
        </div>

        <div className="card-footer bg-white border-0 text-right pt-0">
          <span className="card-text text-muted">{price} kr. {units}</span>
        </div>
      </div>
    </Link>
  )
}
